import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  errorNotify,
  infoNotify,
  successNotify,
} from "../../../Components/ToastComponent/ToastNotification";
import TextInput from "../../../Components/InputComponents/TextInput";
import SelectInput from "../../../Components/InputComponents/SelectInput";
import CommonButton from "../../../Components/InputComponents/CommonButton";
import {
  Grid,
  Typography,
  Paper,
  Button,
  Checkbox,
  TextField,
  Autocomplete,
  RadioGroup,
  Box,
  Radio,
  FormControlLabel,
  Modal,
  IconButton,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import ProcessView from "./ViewProcedureDetailsModal";
import { axiosAPI } from "../../../Components/AxiosComponents/Axios";

const AddRecruitmentProcedureMapping = () => {
  const navigate = useNavigate();

  const [candidateData, setCandidateData] = useState({
    country: "",
    recruitmentProcedure: "",
    profession: "",
    status: 1,
    effectiveDate: "",
  });

  const [openModal, setOpenModal] = useState(false);
  const [selectedProcedure, setSelectedProcedure] = useState(null);
  const [errors, setErrors] = useState({});

  const handleViewProcedure = (option) => {
    setSelectedProcedure(option);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedProcedure(null);
  };

  const validateForm = () => {
    const mandatoryFields = [
      { field: "country", label: "Country" },
      { field: "profession", label: "Profession" },
      { field: "recruitmentProcedure", label: "Recruitment Procedure" },
    ];

    let formErrors = {};
    for (let { field, label } of mandatoryFields) {
      if (!candidateData[field]) {
        formErrors[field] = `${label} is required.`;
      }
    }

    setErrors(formErrors);
    if (Object.keys(formErrors).length > 0) {
      Object.values(formErrors).forEach((error) => {
        errorNotify(error);
      });
      return false;
    }
    return true;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setErrors({
      ...errors,
      [name]: "",
    });
    setCandidateData({
      ...candidateData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      // RecruitmentProcedureMapping/add

      axiosAPI
        ?.post("RecruitmentProcedureMapping/add", {
          RPM_CountryId: candidateData?.country,
          RPM_ProfessionId: candidateData?.profession,
          RPM_Procedure: candidateData?.recruitmentProcedure,
          RPM_Status: candidateData?.status,
          RPM_EffectiveDate: candidateData?.effectiveDate,
        })
        .then((res) => {
          if (res?.data?.success) {
            successNotify(res?.data?.message);
            navigate(`/RecruitmentMappingProcedure`);
          } else {
            infoNotify(res?.data?.message);
          }
        })
        .catch((err) => {
          errorNotify("Something went wrong!");
        });
    }
  };

  const [recruitmentOptions, setRecruitmentOptions] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [professionList, setProfessionList] = useState([]);

  const getData = async () => {
    try {
      const res = await axiosAPI.get(`/RecruitmentProcedure/list`);

      const filteredData = res?.data?.data?.filter(
        (proc) => proc.RP_IsActive !== 0
      );

      setRecruitmentOptions(filteredData);
    } catch (err) {
      console.error(err);
    }
  };

  const getCountries = async () => {
    try {
      const res = await axiosAPI.get(`/RecruitmentCountry/active/list`);
      setCountryList(res?.data?.data || []);
    } catch (err) {}
  };

  const getProfession = async () => {
    try {
      const res = await axiosAPI.get(`/Profession/active/list`);
      setProfessionList(res?.data?.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getData();
    getCountries();
    getProfession();
  }, []);

  return (
    <>
      {openModal ? (
        <ProcessView
          selectedProcedure={selectedProcedure}
          handleCloseModal={handleCloseModal}
        />
      ) : (
        <Paper
          sx={{
            maxWidth: `100vw`,
            padding: 2,
            margin: "auto",
            boxShadow: "none",
            overflowX: "auto",
            fontFamily: "Geist, sans-serif",
            minHeight: "100%",
          }}
        >
          <Typography
            variant="h5"
            sx={{ fontWeight: 600, fontFamily: "Geist, sans-serif" }}
            mb={2}
          >
            Add Recruitment Procedure Mapping
          </Typography>

          <Grid
            container
            sx={{
              border: "1px solid lightgrey",
              borderRadius: "10px",
              padding: "20px",
            }}
          >
            <Grid
              item
              sx={{ padding: "5px" }}
              xs={12}
              sm={6}
              md={4}
              lg={3}
              xl={2}
            >
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
              >
                Country <span style={{ color: "red" }}> *</span>
              </Typography>
              <SelectInput
                value={candidateData.country}
                name="country"
                onChange={handleInputChange}
                options={countryList?.map((item) => ({
                  value: item.RC_Id,
                  label: item.RC_Name,
                }))}
                placeholder="Select Country"
              />
            </Grid>

            <Grid
              item
              sx={{ padding: "5px" }}
              xs={12}
              sm={6}
              md={4}
              lg={3}
              xl={2}
            >
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
              >
                Profession
                <span style={{ color: "red" }}> *</span>
              </Typography>
              <SelectInput
                value={candidateData.profession}
                name="profession"
                onChange={handleInputChange}
                options={professionList?.map((item) => ({
                  value: item?.PI_Id,
                  label: item?.PI_Name,
                }))}
                placeholder="Select Profession"
              />
            </Grid>

            {/* <Grid item sx={{ padding: "5px" }} xs={12} sm={6} md={4}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
          >
            Status <span style={{ color: "red" }}> *</span>
          </Typography>
          <SelectInput
            value={candidateData.status}
            name="status"
            onChange={handleInputChange}
            options={[
              { value: "1", label: "Active" },
              { value: "0", label: "Inactive" },
            ]}
            placeholder="Select Status"
          />
        </Grid> */}

            <Grid item xs={12} sx={{ padding: "5px" }} my={2}>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
              >
                Recruitment Procedure
              </Typography>

              <RadioGroup
                value={candidateData.recruitmentProcedure}
                name="recruitmentProcedure"
                onChange={handleInputChange}
              >
                <Grid container spacing={1}>
                  {recruitmentOptions?.length > 0 ? (
                    recruitmentOptions.map((option) => (
                      <Grid item xs={12} sm={6} md={6} lg={4}>
                        <Paper
                          key={option.value}
                          variant="outlined"
                          sx={{
                            padding: 2,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            border: "1px solid lightgrey",
                            minHeight: "120px",
                            border:
                              option.RP_Id == candidateData.recruitmentProcedure
                                ? "2px solid #006CB8"
                                : "",
                            background:
                              option.RP_Id == candidateData.recruitmentProcedure
                                ? "#0095ff26"
                                : "",
                          }}
                        >
                          <FormControlLabel
                            value={option?.RP_Id}
                            control={<Radio />}
                            label={
                              <Box>
                                <Typography
                                  variant="subtitle1"
                                  sx={{
                                    fontWeight: 600,
                                  }}
                                >
                                  {option?.RP_Name}
                                </Typography>
                                <Typography variant="body2">
                                  {option?.stages
                                    ?.map((a) => a?.RPS_Name)
                                    .filter(Boolean)
                                    .join(", ")}
                                </Typography>{" "}
                              </Box>
                            }
                            sx={{ margin: 0 }}
                          />

                          <IconButton
                            onClick={() => handleViewProcedure(option)}
                            sx={{ ml: 2 }}
                          >
                            <VisibilityIcon />
                          </IconButton>
                        </Paper>
                      </Grid>
                    ))
                  ) : (
                    <Grid item xs={12}>
                      <Typography
                        
                        sx={{
                          fontFamily: "Geist, sans-serif",
                          fontSize: "18px",
                          color: "text.secondary",
                          textAlign: "center",
                          py: 2,
                          border:'1px solid lightgrey',
                          borderRadius:1,
                          
                        }}
                      >
                        No recruitment procedures found
                      </Typography>
                    </Grid>
                  )}
                </Grid>
              </RadioGroup>
            </Grid>
          </Grid>

          <Grid container spacing={2} justifyContent="flex-end" sx={{ mt: 3 }}>
            <Grid item>
              <CommonButton
                variant="outlined"
                customColor="#B0BEC5"
                onClick={() => {
                  navigate(`/RecruitmentMappingProcedure`);
                }}
              >
                Cancel
              </CommonButton>
            </Grid>
            <Grid item>
              <CommonButton
                variant="contained"
                customColor="#007BFF"
                onClick={handleSubmit}
              >
                Save
              </CommonButton>
            </Grid>
          </Grid>
        </Paper>
      )}
    </>
  );
};

export default AddRecruitmentProcedureMapping;
